var _path, _g, _g2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscontentFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_56",
    "data-name": "Group 56",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.782,
    height: 43.767,
    viewBox: "0 0 41.782 43.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1252.234,265.71a20.891,20.891,0,1,1-20.891-20.892A20.89,20.89,0,0,1,1252.234,265.71Z",
    transform: "translate(-1210.451 -244.818)",
    fill: "#f6c36c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(12.763 24.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1253.091,300.312a1.019,1.019,0,0,1-.7-.274,10.087,10.087,0,0,0-6.514-2.6,9.968,9.968,0,0,0-7.264,2.6,1.022,1.022,0,0,1-1.411-1.478,12.445,12.445,0,0,1,16.581-.009,1.022,1.022,0,0,1-.7,1.77Z",
    transform: "translate(-1236.89 -295.382)",
    fill: "#562912"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(7.265 11.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(0.951 6.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(20.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1275.374,287.855a.658.658,0,0,1-.191-.028l-4.437-1.295a.682.682,0,0,1-.122-1.259s3.452-1.785,4.485-2.335a.681.681,0,1,1,.64,1.2c-.58.309-1.921,1.007-2.989,1.561l2.805.819a.681.681,0,0,1-.191,1.335Z",
    transform: "translate(-1270.255 -282.857)",
    fill: "#562912"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1228.209,287.855a.681.681,0,0,1-.191-1.335l2.8-.819c-1.068-.554-2.409-1.252-2.99-1.561a.681.681,0,1,1,.641-1.2c1.033.551,4.485,2.335,4.485,2.335a.682.682,0,0,1-.122,1.259l-4.437,1.295A.655.655,0,0,1,1228.209,287.855Z",
    transform: "translate(-1227.472 -282.857)",
    fill: "#562912"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(22.353 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1277.183,273.42a.7.7,0,0,1-.1-.008,7.815,7.815,0,0,1-5.173-3.4.681.681,0,0,1,1.164-.707,6.547,6.547,0,0,0,4.217,2.756.682.682,0,0,1-.1,1.355Z",
    transform: "translate(-1271.807 -268.982)",
    fill: "#562912"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1226.182,273.42a.682.682,0,0,1-.1-1.355,6.478,6.478,0,0,0,4.216-2.756.681.681,0,0,1,1.164.707,7.813,7.813,0,0,1-5.173,3.4A.7.7,0,0,1,1226.182,273.42Z",
    transform: "translate(-1225.502 -268.981)",
    fill: "#562912"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1248.744,335.485",
    transform: "translate(-1230.259 -291.718)",
    fill: "#1ccb32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscontentFace);
export default __webpack_public_path__ + "static/media/discontent-face.2196c555.svg";
export { ForwardRef as ReactComponent };